import React, { PureComponent } from 'react';
import flow from 'lodash/flow';

import { withTracking, withLocationInfo } from '../../provider';

import RelatedLinks from './component';

class RelatedLinksContainer extends PureComponent {
  render() {
    const {
      injected: {
        tracking: { trackButtonClick },
        location: { isLocationSetByUser },
      },
      categoryLabel,
      subLocationLinks,
    } = this.props;

    if (isLocationSetByUser) return null;

    const componentProps = {
      categoryLabel,
      subLocationLinks,
      onLinkClick: (params) => trackButtonClick('location', params),
    };

    return <RelatedLinks {...componentProps} />;
  }
}

RelatedLinksContainer.defaultProps = {
  injected: {
    tracking: {
      trackButtonClick: () => {},
    },
    location: {
      isLocationSetByUser: false,
    },
  },
};

export default flow(
  withLocationInfo,
  withTracking('related'),
)(RelatedLinksContainer);
